<template>
  <hello-world></hello-world>
</template>

<script>
export default {
  name: "study_model_list"
}
</script>

<style scoped>

</style>
